import { render, staticRenderFns } from "./ResellerHistory.vue?vue&type=template&id=5f8a9d6d"
import script from "./ResellerHistory.vue?vue&type=script&lang=js"
export * from "./ResellerHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports